import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import { PoAck, SupplierBillRequestService } from '../../../services/supplierBillRequest.service';
import { formatDateTime } from '../../../utils/dateUtils';

// ---- F8: "Acknowledged by ... on ..." on the PO page, once the supplier acknowledged it in the portal ----
const SupplierAckLine: React.FC<{ purchaseOrderId: string }> = ({ purchaseOrderId }) => {
  const [ack, setAck] = useState<PoAck | null>(null);
  useEffect(() => {
    let live = true;
    const institutionId = AuthService.getSelectedInstitution();
    if (!institutionId) return undefined;
    SupplierBillRequestService.poAck(institutionId, purchaseOrderId)
      .then(a => { if (live) setAck(a); })
      .catch(() => { /* optional line: hide it when the lookup fails */ });
    return () => { live = false; };
  }, [purchaseOrderId]);
  if (!ack || !ack.acknowledged || !ack.acknowledgedAt) return null;
  return (
    <Typography variant="body2" color="success.main" sx={{ mt: 0.5 }} data-testid="po-supplier-ack">
      Acknowledged by {ack.contactName ?? 'the supplier'}{ack.contactEmail ? ` (${ack.contactEmail})` : ''} on {formatDateTime(ack.acknowledgedAt)}
      {ack.note ? `: "${ack.note}"` : ''}
    </Typography>
  );
};

export default SupplierAckLine;
// ---- end F8 ----
